import { apiClient } from './axios';
import type { AiValidationSummary } from '../types/aiValidation';

export interface AiValidationSummaryParams {
    from: string;
    to: string;
    wordLang?: string;
    meaningLang?: string;
}

export const aiValidationApi = {
    getSummary: (params: AiValidationSummaryParams) =>
        apiClient.get<AiValidationSummary>('/admin/ai-validation/summary', {
            from: params.from,
            to: params.to,
            ...(params.wordLang ? { wordLang: params.wordLang } : {}),
            ...(params.meaningLang ? { meaningLang: params.meaningLang } : {}),
        }),
};
